import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const NumbersSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default NumbersSVG;
